import { connect } from 'react-redux'
import LoadingBar from './component'
import { getLauncherText, getClientText, getPatchNotes } from '../../data'
import { getAttributes, commands, selectors } from '../../imports'

function mapStateToProps(state) {
    const attributes = getAttributes(selectors.getLocale(state))

    return {
        launcherText: getLauncherText(state),
        launcherVersion: selectors.getLauncherBackendVersion(state),
        uiVersion: state.app.uiVersion, // todo: selectors...!
        clientText: getClientText(state),
        patchNotes: attributes.patchNotes ? getPatchNotes(state) : null,
        patchNotesOnClick: () => commands.launcherOpenUrl(attributes.patchNotes),
        steamStartup: selectors.isSteamStartup(state),
        progress: selectors.getProgress(state),
    }
}

export default connect(mapStateToProps)(LoadingBar)



// WEBPACK FOOTER //
// ./src/features/LoadingBar/components/LoadingBar/index.js